(function () {
    'use strict';

    angular
        .module('adminCACMControllers')
        .controller('AdminCACMController', Controller);

    Controller.$inject = ['$scope', '$mdToast', 'govNotificationDelay', 'topBarService', 'adminCACMService'];

    function Controller($scope, $mdToast, govNotificationDelay, topBarService, adminCACMService) {

        topBarService.setModule(undefined);
        topBarService.setTitleAndIcon('Manage CACM', 'fa fa-tachometer');

        $scope.ctrlCtxt = {};

        $scope.refreshAllItemsToIndex = function () {
            $scope.ctrlCtxt.isLoading = true;

            return adminCACMService
                .getReIndexingSummary()
                .then(function (cacmIndexing) {
                    $scope.ctrlCtxt.isLoading = false;
                    $scope.cacmIndexing = cacmIndexing;
                });
        };
        $scope.refreshAllItemsToIndex();

        $scope.synchronizeAllForIndexing = function () {
            return adminCACMService
                    .synchronizeAllForIndexing()
                    .then(function () {
                        $mdToast.show(
                              $mdToast
                                  .simple()
                                  .content('All Data has been queued for Re-Indexing')
                                  .position('top right')
                                  .hideDelay(govNotificationDelay)
                                  .action('OK')
                                  .theme('primary')
                         );

                        $scope.refreshAllItemsToIndex();
                    });
        };
    }
})();